<template>
    <div>

        <form @change="getBLname(bundesland,bezirke)" class="form-inline mb-3">
        <div class="form-row">
            <div class="form-group  mr-2">
                <select disabled  class="custom-select my-1 mr-sm-2" name="bundesland"  v-model="bundesland" id="mylocations-bundesland">
                    <option value="0" disable="true" selected="true">=== Bundesland ===</option>
                    <option v-for="option in bundesland_op" :value="option.BLID" :key="option.BLID">
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group   mr-2">
                <select  class="custom-select my-1 mr-sm-2" name="bezirke"  id="mylocations-bezirke" v-model="bezirke">
                    <option value="0" disable="true" selected="true">=== Bezirke ===</option>
                    <option v-for="option in bezirke_op[bundesland]" :value="option.IDBEZ" :key="option.IDBEZ">
                        {{ option.BEZIRK }}
                    </option>
                </select>
            </div>
        </div>
           <!-- <a class="btn btn-primary p-1" :href="'/suche/baumeister/' + bundeslandName" role="button"><i class="nav-icon fas fa-list"></i> Neue Suche</a> -->
            <button class="btn btn-primary p-1 mr-1" @click="setBezirkWahlLink()"  role="button"><i class="nav-icon fas fa-list"></i> Neue Bezirk auswahl</button>
            <a class="btn btn-primary p-1" href="/seo/alle-branchen" role="button"><i class="nav-icon fas fa-search"></i> Branche ändern</a>

        </form>
    </div>
</template>

<script>

    export default {
        //name: "chainselect",  // using EXACTLY this name is essential
        name: "mylocations2AlleBranchenBundeslandBezirk",

        props: {
            brancheprobs: {
                type: String,
                default: ''
            },
            blidprobs:{
                type: String,
                default: '0'
            },
            bzidprobs:{
                type: String,
                default: '0'
            },
            bundeslandprobs:{
                type: String,
                default: ''
            },
            bezirkprobs:{
                type: String,
                default: ''
            }
        },
        data() {
            return {
                bundesland_op: [],
                bezirke_op: {},
                branche: this.brancheprobs,
                success: '',
                bundesland: this.blidprobs,
                bezirke: this.bzidprobs,
                bundeslandName: this.bundeslandprobs,
                bezirk: this.bezirk,
                bezirkWahlLink: ''
            }
        },

        // props: ['bundesland','bezirke','gemeinde','orte','plz'],
        watch: {},

        methods: {
            setBezirkWahlLink(){
                var urlOri = this.$route.fullPath;
                console.log('URL ====> '+ urlOri);
                var urlArray = urlOri.split('/');
                var last = urlArray.pop();
                let url = urlArray.join('/')
                this.bezirkWahlLink = url
                this.$router.push(url)
                // this.bezirkWahlLink = this.$route.fullPath;
            },
            loadBundesland() {
                axios.get("/mylocations/vue/bundesland").then(response => this.bundesland_op = response.data);
            },
            loadBezirke() {
                axios.get("/mylocations/vue/bezirke").then(response => this.bezirke_op = response.data);

            },

            getBLname(id,idbez){
                axios.get("/mylocations/vue/getBundeslandName/" + id).then(response => {
                    this.bundeslandName = response.data[0];
                }
                );

                axios.get("/mylocations/vue/getBezirkName/" + idbez).then(response => {
                    this.bezirk = response.data[0];
                   // this.ladeseite(this.bundeslandName,this.bezirk);
                    }
                );
            },

            ladeseite(bundeslandname,bezirkname){
                var bezirkArray = bezirkname.split("/");
                var urlbezirkname = '';
                if(bezirkArray.length > 1) {

                    urlbezirkname = bezirkArray[0] + '-' + bezirkArray[1];
                }
                else{
                    urlbezirkname = bezirkname;
                }
                window.location.href = 'https://'+location.hostname+'/suche/' + this.branche.toLowerCase() +'/' + bundeslandname.toLowerCase() + '/' + urlbezirkname.toLowerCase();
            },


            /*
            getBLname: _.debounce(function(id){
                axios.get("/mylocations/vue/getBundeslandName/" + id).then(response => this.bundeslandName = response.data[0]);
                console.log('bundeslandnamein getBlName = ',  this.bundeslandName);
                return this.bundeslandName;
                        }, 500),
            */

        },
        created() {
            this.loadBundesland();
            this.loadBezirke();
            console.log('bin in MyLocations2AlleBranchen')
        },
        mounted() {

        }
    }


</script>

<style scoped>

</style>
